import { BaseGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/base-global-search-link';
import { CoreGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/core-global-search-link';
import { DealerGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/dealer-global-search-link';
import { PersonalizedSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/personalized-search-link/personalized-search-link';

export const BUTTON_DATA = [
  {
    id: 'used_btn',
    label: 'Shop used',
    url: '/used-all/',
    dataTrackingId: 'shop_used_link_click',
  },
  {
    id: 'new_btn',
    label: 'Shop new',
    url: '/new-cars-for-sale/',
    dataTrackingId: 'shop_new_link_click',
  },
  {
    id: 'reviews_btn',
    label: 'Reviews',
    url: '/car-reviews/',
    dataTrackingId: 'shop_reviews_link_click',
  },
  {
    id: 'appraise_btn',
    label: 'Appraise my car',
    url: '/appraisal/',
    dataTrackingId: 'shop_appraise_link_click',
  },
];

export const OPEN_DELAY = 300;
export const INPUT_DELAY = 300;
export const LOOKING_FOR_PLACEHOLDER = "Describe what you're looking for";
export const AUTOSIZED_AREA_LENGTH = 200;
export const INPUT_MIN_HEIGHT = 56;
export const LISTBOX_ID = 'search-results-box';
export const CLOSE_RESULTS_LABEL = 'Close search results';
export const CLEAR_INPUT = 'Clear input field';
export const PRIMING_BOX_COPY = 'Try searching by car name, features, or description';
export const CREATIVE_ID = 'edm-entry-homepage-semantic-search';
export const GLOBAL_NAV_CREATIVE_ID = 'edm-entry-global-nav-semantic-search';
export const CREATIVE_ID_SEMANTIC = 'edm-entry-semantic-inventory-search';
export const FOUND_VIN_SCREEN_CREATIVE_ID = 'vdp-found-semantic-inventory-search';
export const ERROR_SCREEN_CREATIVE_ID = 'error-state-semantic-inventory-search';
export const CLICK_OR_TAP_ACTION = 'click or tap action';
export const KEYBOARD_ACTION = 'keyboard action ';
export const SELECT_OPTION = 'Please select an option below';
export const API_LINKS_TYPE = {
  RANKINGS: 'RANKINGS',
  APPRAISAL: 'APPRAISAL',
  COMPARE: 'COMPARE',
  FORUMS: 'FORUMS',
  DEALERSHIP: 'DEALERSHIP',
  DEALERSHIP_LANDING: 'DEALERSHIP_LANDING',
  DEALERSHIP_PROFILE: 'DEALERSHIP_PROFILE',
  BUILD_AND_PRICE: 'BUILD_AND_PRICE',
  RESEARCH: 'RESEARCH',
};
export const LINK_COMPONENTS = {
  BASE: 'BASE',
  CORE: 'CORE',
  DEALER: 'DEALER',
  SEARCH: 'SEARCH',
};
export const GLOBAL_SEARCH_LINKS_COMPONENTS_MAP = {
  [LINK_COMPONENTS.BASE]: {
    component: BaseGlobalSearchLink,
  },
  [LINK_COMPONENTS.CORE]: {
    component: CoreGlobalSearchLink,
  },
  [LINK_COMPONENTS.DEALER]: {
    component: DealerGlobalSearchLink,
  },
  [LINK_COMPONENTS.SEARCH]: {
    component: PersonalizedSearchLink,
  },
};
